import icLocationGray from 'assets/icons/ic_location_gray.svg';
import icPhone from 'assets/icons/ic_phone.svg';
import imgBack from 'assets/icons/iconArrowLeft.svg';
import icReload from 'assets/icons/ic_reload.svg';
import icUserRed from 'assets/icons/ic_user_red.svg';
import icUserChecked from 'assets/icons/ic_user_checked.svg';
import icTruck from 'assets/icons/ic_truck.svg';
import icBoxRed from 'assets/icons/ic_box_red.svg';
import icPlus from 'assets/icons/ic_plus.svg';
import icBoxGray from 'assets/icons/ic_box_gray.svg';
import icWeightGray from 'assets/icons/ic_weight_gray.svg';
import icMoneyGray from 'assets/icons/ic_money_gray.svg';
import icArrowRight from 'assets/icons/arrow-right.svg';
import icArrowService from 'assets/icons/ic_arrow_service.svg';
import icExportExcel from 'assets/icons/ic_export_excel.svg';
import icHistoryExcel from 'assets/icons/ic_history_excel.svg';
import icImportExcel from 'assets/icons/ic_import_excel.svg';
import iconRadio from 'assets/icons/iconRadio.svg';
import iconRadioChecked from 'assets/icons/iconRadioChecked.svg';
import ic_action_order from 'assets/icons/ic_action_order.svg'
import icLogo from 'assets/icons/ic_logo.svg'
import iconLogoApp from 'assets/icons/iconApp.svg'
import icLock from 'assets/icons/ic_lock.svg'
import icUnLock from 'assets/icons/ic_unlock.svg'
import icEditNew from 'assets/icons/ic_edit_new.svg'
////
import backgroundImageA6 from 'assets/formPrint/a6new.svg';
/////
import icNavCreateOrder from 'assets/icons/ic_nav_create_order.svg'

export const icon = {
  icLocationGray,
  icPhone,
  imgBack,
  icReload,
  icUserRed,
  icUserChecked,
  icTruck,
  icBoxRed,
  icPlus,
  icBoxGray,
  icWeightGray,
  icMoneyGray,
  icArrowRight,
  icArrowService,
  icExportExcel,
  icHistoryExcel,
  icImportExcel,
  iconRadio,
  iconRadioChecked,
  ic_action_order,
  //////////////////
  icLogo,
  iconLogoApp,
  //////////////////
  icLock,
  icUnLock,
  icEditNew,
  ////////////////
  backgroundImageA6,
  /////////////////
  icNavCreateOrder,
}